export interface Currency {
  code: string;
  name: string;
  zeroDecimal?: boolean;
  note?: string;
  noteTooltip?: string;
}

export const SUPPORTED_CURRENCIES: Currency[] = [
  { code: "AUD", name: "Australian Dollar" },
  { 
    code: "BRL", 
    name: "Brazilian Real", 
    note: "In-country only",
    noteTooltip: "This currency is supported as a payment or settlement currency only for in-country PayPal accounts. If your account is based outside Brazil, PayPal will convert money into your account's primary currency."
  },
  { code: "CAD", name: "Canadian Dollar" },
  { 
    code: "CNY", 
    name: "Chinese Renminbi", 
    note: "In-country only",
    noteTooltip: "This currency is supported as a payment or settlement currency only for in-country PayPal accounts. If your account is based outside China, PayPal will convert money into your account's primary currency."
  },
  { code: "CZK", name: "Czech Koruna" },
  { code: "DKK", name: "Danish Krone" },
  { code: "EUR", name: "Euro" },
  { code: "HKD", name: "Hong Kong Dollar" },
  { code: "HUF", name: "Hungarian Forint", zeroDecimal: true },
  { code: "ILS", name: "Israeli New Shekel" },
  { code: "JPY", name: "Japanese Yen", zeroDecimal: true },
  { 
    code: "MYR", 
    name: "Malaysian Ringgit", 
    note: "In-country only",
    noteTooltip: "This currency is supported as a payment or settlement currency only for in-country PayPal accounts. If your account is based outside Malaysia, PayPal will convert money into your account's primary currency."
  },
  { code: "MXN", name: "Mexican Peso" },
  { code: "TWD", name: "New Taiwan Dollar", zeroDecimal: true },
  { code: "NZD", name: "New Zealand Dollar" },
  { code: "NOK", name: "Norwegian Krone" },
  { code: "PHP", name: "Philippine Peso" },
  { code: "PLN", name: "Polish Złoty" },
  { code: "GBP", name: "Pound Sterling" },
  { code: "SGD", name: "Singapore Dollar" },
  { code: "SEK", name: "Swedish Krona" },
  { code: "CHF", name: "Swiss Franc" },
  { code: "THB", name: "Thai Baht" },
  { code: "USD", name: "United States Dollar" },
];

export const CURRENCY_MAP = SUPPORTED_CURRENCIES.reduce((acc, curr) => {
  acc[curr.code] = curr;
  return acc;
}, {} as Record<string, Currency>);

export function getCurrencySymbol(code: string): string {
  const symbols: Record<string, string> = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "A$",
    CAD: "C$",
    CHF: "CHF",
    HKD: "HK$",
    NZD: "NZ$",
    SGD: "S$",
    SEK: "kr",
    NOK: "kr",
    DKK: "kr",
    PLN: "zł",
    THB: "฿",
    MXN: "MX$",
    BRL: "R$",
    ILS: "₪",
    PHP: "₱",
    TWD: "NT$",
    CZK: "Kč",
    HUF: "Ft",
    MYR: "RM",
  };
  return symbols[code] || code;
}

export function isZeroDecimalCurrency(code: string): boolean {
  return CURRENCY_MAP[code]?.zeroDecimal || false;
}

export const DEFAULT_CURRENCY = 'USD';

